import { Handle, Position } from "@xyflow/react";
interface ReceivableNodeData {
  id: string;
  name: string;
  totalAmount: number;
  bankId: string;
  partnerName?: string;
}

interface ReceivableNodeProps {
  data: ReceivableNodeData;
  isConnectable: boolean;
}

function ReceivableNode({ data, isConnectable }: ReceivableNodeProps) {
  return (
    <div
      className="p-3 rounded-lg bg-white shadow-md border-2 border-blue-500"
      style={{ minWidth: "180px" }}
    >
      <Handle
        type="source"
        position={Position.Right}
        id="right"
        style={{ background: "#22c55e" }}
        isConnectable={isConnectable}
      />

      <div className="text-center">
        <div className="font-bold text-sm">{data.name}</div>
        {data.partnerName && (
          <div className="text-xs text-gray-500 mt-1">合作方：{data.partnerName}</div>
        )}
        <div className="text-xs text-blue-600 mt-1">
          總金額（含稅): ${Math.round(data.totalAmount || 0).toLocaleString()}
        </div>
      </div>
    </div>
  );
}

export default ReceivableNode;
